import { GetTeamMetricsAppsSummaryAverageWholeTeamQuery } from '../../../queries/team-metrics/calendar/get-team-metrics-apps-summary-average-whole-team.query';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { TeamMetricsAppsSummaryAverageWholeTeamParentAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/calendar/team-metrics-app-summary-average-whole-team-parent.aggregate-root.mapper';
import { GetTeamMetricsAppsSummaryResponseDto } from '../../../dtos/team-metrics/calendar/get-team-metrics-apps-summary.response.dto';
import { GetTeamMetricsAppsSummaryAverageWholeTeamRequestDto } from '../../../dtos/team-metrics/calendar/get-team-metrics-apps-summary-average-whole-team.request.dto';

export class GetTeamMetricsAppsSummaryAverageWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetTeamMetricsAppsSummaryAverageWholeTeamQuery,
    protected readonly mapper: TeamMetricsAppsSummaryAverageWholeTeamParentAggregateRootMapper
  ) {}

  async get(
    props: GetTeamMetricsAppsSummaryAverageWholeTeamRequestDto
  ): Promise<GetTeamMetricsAppsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `TeamMetricsAppsSummaryAverageWholeTeamComponentController.get encountered an error ${error}`
      );
    }
  }
}
